<template>
  <el-pagination
    v-if="total > pageSize"
    class="wrap-pagination"
    :total="total"
    :layout="layout"
    :page-sizes="pageSizes"
    :current-page="currentPage"
    :page-size="pageSize"
    :background="background"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange">
  </el-pagination>
</template>

<script>
export default {
  props: {
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    pageSizes: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    background: {
      type: Boolean,
      default: false
    }
  },
  data() { return {} },
  methods: {
    handleSizeChange(val) {
      this.$emit('size-change', val)
    },
    handleCurrentChange(val) {
      this.$emit('current-change', val)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
